<template>
  <Header />
  <main class="main" style="min-height: 432px">
    <router-view />
  </main>
  <Footer />
</template>

<script>
import { onMounted } from "vue";
import Header from "./components/header.vue";
import Footer from "./components/footer.vue";
import { AppService } from "./app.service";

export default {
  components: {
    Header,
    Footer,
  },
  setup() {
    const $appService = new AppService();

    onMounted(() => {
      initChatwoot();
    });

    async function initChatwoot() {
      const response = await $appService.getChatwoot();
      if (!response.data?.ativo) return;
      if (window.chatwootSDK) return;

      const { BASE_URL, websiteToken, position, type, launcherTitle } = {
        ativo: response.data.ativo,
        BASE_URL: response.data.BASE_URL,
        websiteToken: response.data.websiteToken,
        position: response.data.position,
        type: response.data.type,
        launcherTitle: response.data.launcherTitle,
      };

      window.chatwootSettings = { position, type, launcherTitle };

      const script = document.createElement("script");
      script.src = `${BASE_URL}/packs/js/sdk.js`;
      script.async = true;
      script.onload = function () {
        window.chatwootSDK.run({ websiteToken, baseUrl: BASE_URL });
      };
      script.onerror = function () {
        console.error("[Chatwoot] Falha ao carregar o SDK:", script.src);
      };
      document.head.appendChild(script);
    }
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
